<div class="col-md-12 modal-body">
    <app-cycle-validation-list [cyclesValidation]="cyclesValidation"></app-cycle-validation-list>
</div>
